import { isoZ, z } from 'my-zod'

export const taxPolicyModel = z.object({
  id: z.number(),
  outfitterId: z.number(),
  configurationVersionId: z.number(),
  unit: z.enum(['flat', 'percentage']),
  amount: z.number().positive() /** if percentage, 7 is 7%. if flat, USD in cents */,
  title: z.string(),
  beginDate: isoZ.date(),
  endDate: isoZ.date().nullable()
})

export type taxPolicyModel = z.infer<typeof taxPolicyModel>

export const taxConfigurationModel = z.object({
  outfitterId: z.number(),
  versionId: z.number(),
  createdDate: isoZ.instant(),

  policies: taxPolicyModel
    .pick({
      id: true,
      unit: true,
      amount: true,
      title: true,
      beginDate: true,
      endDate: true
    })
    .array()
})

export type taxConfigurationModel = z.infer<typeof taxConfigurationModel>
